import { ButtonERP } from "@finanedi.es/storybook"
import { faGear } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

interface VerifactuPendingProps {
  /**
   * Boolean to control the visibility of the card.
   */
  showCard: boolean
  /**
   * Function to toggle the modal open state.
   */
  toggleOpenModal: () => void
}

export const VerifactuPending = ({
  showCard,
  toggleOpenModal,
}: VerifactuPendingProps) => {
  const { t } = useTranslation()

  if (!showCard) return

  return (
    <div className='tw-flex tw-items-center tw-justify-between tw-text-left'>
      <p>{t("verifactu.configCard.statusPending.description")}</p>

      <div className='tw-min-w-32 tw-place-content-end tw-grid'>
        <ButtonERP
          type='button'
          icon={
            <span className='tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center'>
              <FontAwesomeIcon icon={faGear} />
            </span>
          }
          customize={{
            type: "primary",
            size: "md",
          }}
          onClick={() => toggleOpenModal()}
          label={`${t("verifactu.configCard.statusPending.buttonLabel")}`}
        />
      </div>
    </div>
  )
}
